/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
import {
  isApp,
  exclusiveidFn,
  pointParams,
  clickburiedPoint,
  commonburiedPoint,
  basepath
} from './config'
import router from '../../../router'
import qs from 'qs'
import wx from 'weixin-js-sdk'

var arg = isApp()
export default {
  arg: arg,
  argFunc(h5Func, miniFunc, appFunc) {
    if (arg == '') {
      if (typeof h5Func == 'function') h5Func()
    } else if (arg.indexOf('xcx') >= 0) {
      if (typeof miniFunc == 'function') miniFunc()
    } else {
      if (typeof appFunc == 'function') appFunc()
    }
  },
  // creater: gaoenhui --h5&mini&app --h5内部跳转加arg参数
  // h5内部跳转 参数type支持'push'、'replace' 默认'push'
  argLink(link, type) {
    router[type ? type : 'push']({
      path: `${link.path}?${arg}`,
      query: link.query
    })
  },
  // creater: gaoenhui --h5&mini&app --h5内部跳转加arg参数
  argStaticLink(link) {
    window.location = link + (link.indexOf('?') >= 0 ? arg : arg ? '?' + arg : '')
  },
  goIntegral() {
    if (arg == '') {
      router.push({
        path: '/integral'
      })
    } else if (arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'goIntegral'
        })
      )
    } else {
      wx.miniProgram.navigateTo({
        url: '/pages/integral/integralCenter/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    }
  },
  goIntegralDetail() {
    if (arg == '') {
      router.push({
        path: '/integraldetails'
      })
    } else if (arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'nineteen',
          nineteentype: 'nineteenintegral'
        })
      )
    } else {
      wx.miniProgram.navigateTo({
        url: '/pages/integral/integral/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    }
  },
  goIndex() {
    // creater: gaoenhui --h5&mini&app --跳转首页
    if (arg == '') {
      router.push({
        path: '/'
      })
    } else if (arg.indexOf('xcx') >= 0) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    } else {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'goIndex'
        })
      )
    }
  },
  goChannelIndex(channelid) {
    // creater: gaoenhui --h5&mini&app --跳转专区首页
    if (arg == '') {
      router[window.location.pathname == '/indexchannel' ? 'replace' : 'push']({
        path: '/indexchannel',
        query: {
            channelid: channelid
          }
        })
        if (router.history.current.meta.keepAlive) router.history.current.meta.keepAlive = false
        window.scrollTo(0, 0)
    } else if (arg.indexOf('xcx') >= 0) {
      wx.miniProgram.navigateTo({
        url: '/pages/indexChannel/main?channelid=' + channelid + '&exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    } else {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'goChannelIndex',
          channelid: channelid
        })
      )
    }
  },
  navTitle(title) {
    // creater: gaoenhui --app --顶部标题
    if (arg != '' && arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'navTitle',
          title: title
        })
      )
    }
  },
  saveimg(img) {
    // creater: gaoenhui --app --图片保存
    if (arg != '' && arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'saveimg',
          img: img
        })
      )
    }
  },
  /**
   * 将商品添加到确认订单的流程中。
   * @param {Object} shopConfirmResult - 包含订单相关信息的对象。
   * @param {String} paramsStr - h5&mini所需参数，类型string，用于页面跳转时传递参数。
   * @param {Object} apparams - app所需参数，类型object，用于像app传递参数
   */
  addToConfirmOrder(shopConfirmResult, paramsStr = '', apparams = {}) {
    if (arg == '') {
      // 当arg为空时，将paramsStr解析为对象，并通过router跳转到订单页面，传递解析后的参数。
      const params = qs.parse(paramsStr)
      router.push({
        path: '/order',
        query: params
      })
    } else if (arg.indexOf('xcx') >= 0) {
      // 当arg包含'xcx'时，准备小程序订单页面跳转所需参数，并调用wx.miniProgram.navigateTo进行跳转。
      shopConfirmResult.orderHadOnShow = 0
      shopConfirmResult.isInitData = 1
      shopConfirmResult.live_id = ''
      shopConfirmResult.type = 'addToConfirmOrder'
      wx.miniProgram.navigateTo({
        url:
          '/pages/order/main?' +
          paramsStr +
          '&shopConfirmResult=' +
          JSON.stringify(shopConfirmResult) +
          '&scenepoint=' +
          encodeURIComponent(window.document.title) +
          '&exclusiveid=' +
          exclusiveidFn() +
          pointParams('&')
      })
    } else {
      // 当arg为'app'||'ckapp'时，准备订单确认页面所需数据，并通过commonburiedPoint埋点记录订单确认操作。

      var obj = {
        type: 'addToConfirmOrder',
        skuids: shopConfirmResult.skuidArr.join(),
        item_num: shopConfirmResult.itemNum.join(),
        from: shopConfirmResult.from,
        ...apparams
      }
      commonburiedPoint({
        data: {
          scenepoint: window.document.title,
          scenedesc: window.location.href,
          url: 'order-confirm'
        },
        rnType: 'addToConfirmOrder',
        callback: () => {
          // 埋点完成后，通过postMessage向React Native发送订单数据。
          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
        }
      })
    }
  },
  shareFriends(obj, pt) {
    var xcxObj = { type: 'shareFriends' },
      objdata = obj || {}
    var params = Object.assign(xcxObj, objdata)
    if (!pt && arg.indexOf('xcx') >= 0) {
      let link = params.link.indexOf('http') == 0 ? params.link : basepath + params.link
      params.link = link.indexOf('?') >= 0 ? link + arg : link + '?1=1' + arg
      wx.miniProgram.postMessage({ data: params })
    } else if (pt == 'app' && arg.indexOf('app') >= 0) {
      window.ReactNativeWebView.postMessage(JSON.stringify(params))
    }
  },
  goItemDetail(itembaseid, query, scenepoint, pointparams) {
    clickburiedPoint({
      url: 'ckysdatacenter/itemclick/save',
      data: {
        itemid: itembaseid,
        scenepoint: scenepoint ? scenepoint : 'OTHERACT',
        ...(scenepoint ? {} : { scenedesc: window.location.href })
      },
      callback: () => {
        this.argFunc(
          function () {
            // 强制刷新当前页面（优先使用 vue-router 软刷新；回退到 window.reload 做硬刷新）
            let isProductRouter = false
            if (router && window.location.pathname == '/productdetail') {
              isProductRouter = true
            }
            router.push({
              path: '/productdetail',
              query: {
                itemid: itembaseid,
                ...query
              }
            })
            if (isProductRouter) {
              router.go(0)
            }
          },
          function () {
            const params = qs.stringify(query)
            console.log(params)
            wx.miniProgram.navigateTo({
              url:
                '/pages/product/main?itemid=' +
                itembaseid +
                '&' +
                params +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          },
          function () {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'goItemDetail',
                itembaseid: itembaseid,
                ...query
              })
            )
          }
        )
      }
    })
  },

  // creater: gaoenhui --h5&mini&app --跳转购物车
  goCart() {
    this.argFunc(
      function () {
        router.push({
          path: '/cart'
        })
      },
      function () {
        wx.miniProgram.reLaunch({
          url: '/pages/cart/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
        })
      },
      function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'gocart'
          })
        )
      }
    )
  },
  goCategroy(paramsStr = '') {
    const params = qs.parse(paramsStr)
    this.argFunc(
      function () {
        router.push({
          path: '/classification',
          query: params
        })
      },
      function () {
        wx.miniProgram.reLaunch({
          url: '/pages/category/main?exclusiveid=' + exclusiveidFn() + pointParams('&')+'&'+paramsStr
        })
      },
      function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goCategroy',
            ...params
          })
        )
      }
    )
  },
  goBestSellerList() {
    this.argFunc(
      function () {
        router.push({
          path: '/bestsell'
        })
      },
      function () {
        wx.miniProgram.reLaunch({
          url: '/pages/bestsell/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
        })
      },
      function () {
        var obj = {
          type: 'goBestSellerList'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    )
  },
  goCategoryItem(obj = {}, _this) {
    this.argFunc(
      function () {
        if (obj.categoryid) _this.$store.commit('CATEGORY_ID', obj.categoryid)
        _this.$store.commit('CATEGORY_SONID', obj.categorysonid)
        var vuex =
          localStorage.getItem('vuex-along') &&
          JSON.stringify(localStorage.getItem('vuex-along')) != '"{}"'
            ? JSON.parse(localStorage.getItem('vuex-along'))
            : { root: {} }
        vuex.root.categoryId = obj.categoryid
        vuex.root.categorySonId = obj.categorysonid
        localStorage.setItem('vuex-along', JSON.stringify(vuex))
        window.location.href = '/productCategory?title=' + obj.categorypagetitle
      },
      function () {
        var categorysonidtemp = !obj.categorysonid ? 'all' : obj.categorysonid
        wx.miniProgram.navigateTo({
          url:
            '/pages/prolist/main?title=' +
            obj.categorypagetitle +
            '&categoryid=' +
            obj.categoryid +
            '&categorysonid=' +
            categorysonidtemp +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      },
      function () {
        var appobj = {
          type: 'categoryItem',
          categoryid: obj.categoryid || '',
          categorysonid: obj.categorysonid || '',
          title: obj.categorypagetitle || ''
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(appobj))
      }
    )
  },
  // creater: gaoenhui --h5&mini&app --奖品列表
  goPrize() {
    this.argFunc(
      function () {
        router.push({
          path: '/prize'
        })
      },
      function () {
        wx.miniProgram.navigateTo({
          url:
            '/pages/personalcenter/pages/myprize/main?exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      },
      function () {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'nineteen',
            nineteentype: 'nineteenprize'
          })
        )
      }
    )
  },
  goCommunity(communityTab = 1, obj = {}, _this) {
    this.argFunc(
      function () {
        if (obj.ismyself == 1 || Object.keys(obj).length == 0) {
          _this.$store.commit('COMMUNITY_TAB', communityTab)
          router.push('/community')
        } else {
          _this.$store.commit('COMMUNITY_CENTER_TAB', 0)
          router.push('/communitycenter' + '?authorid=' + (obj.authorid || ''))
        }
      },
      function () {
        if (obj.ismyself == 1 || Object.keys(obj).length == 0) {
          wx.miniProgram.reLaunch({
            url:
              '/pages/communityindex/main?communityTab=' +
              communityTab +
              '&exclusiveid=' +
              exclusiveidFn() +
              pointParams('&')
          })
        } else {
          wx.miniProgram.navigateTo({
            url:
              '/pages/community/communityCenter/main?authorid=' +
              (obj.authorid || '') +
              '&exclusiveid=' +
              exclusiveidFn() +
              pointParams('&')
          })
        }
      },
      function () {
        if (communityTab == 0) {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'goCommunityHomePage',
              authorid: obj.authorid || '',
              ismyself: obj.ismyself || ''
            })
          )
        } else {
          window.ReactNativeWebView.postMessage(
            JSON.stringify({
              type: 'goCommunity'
            })
          )
        }
      }
    )
  },
  // creater: gaoenhui --h5&mini&app --新品试用 app交互为新增，未曾告知app
  goNewproducthome() {
    this.argFunc(
      () => {
        router.push('/newproducthome')
      },
      () => {
        wx.miniProgram.navigateTo({
          url:
            '/pages/newproducttrial/home/main?' +
            '&scenepoint=' +
            encodeURIComponent(window.document.title) +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      },
      () => {
        var obj = {
          type: 'goNewproducthome'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    )
  },
  // creater: gaoenhui --h5&mini&app --个人信息 app交互为新增，未曾告知app
  goUserinfo() {
    this.argFunc(
      () => {
        router.push('/perinfo')
      },
      () => {
        wx.miniProgram.navigateTo({
          url:
            '/pages/personal/pages/personalInfo/main?' +
            '&scenepoint=' +
            encodeURIComponent(window.document.title) +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      },
      () => {
        var obj = {
          type: 'goUserinfo'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    )
  },
  // creater: gaoenhui --h5&mini&app --个人中心 app交互为新增，未曾告知app
  goUser() {
    this.argFunc(
      () => {
        router.push('/percen')
      },
      () => {
        wx.miniProgram.reLaunch({
          url:
            '/pages/user/main?' +
            '&scenepoint=' +
            encodeURIComponent(window.document.title) +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      },
      () => {
        var obj = {
          type: 'goUser'
        }
        window.ReactNativeWebView.postMessage(JSON.stringify(obj))
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/js/app_interactive.js